/* eslint-disable */
const trigger = (items, links,) => {
	const config = {
		threshold: 0,
		rootMargin: `-20% 0px -80% 0px`,
	}

	const arr = [items[0].id];

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const id = entry.target.id;

			if (entry.isIntersecting) {
				!arr.includes(id) && arr.push(id);
			} else {
				if (entry.boundingClientRect.y > entry.rootBounds.y && arr.length > 1) {
					arr.includes(id) && arr.splice(arr.indexOf(id), 1);
				}
			}

			links.forEach(link => {
				const href = link.getAttribute('href');
				if (href === `#${arr[arr.length - 1]}`) {
					const name = document.querySelector(".anchor-sticky .name");
					if (name) name.innerText = link.innerText;
					link.classList.add('active');

				} else {
					link.classList.remove('active');
				}
			});

		});
	}, config);




	items.forEach(item => observer.observe(item));
};
export default trigger;
